import { setFulfilled, setPending, setRejected } from '@ms/yammer-data-support';
import { Reducer } from 'redux';

import { NetworkQuestionSettingsLoadAction } from '../../domains/networkQuestionSettings/actions.types';
import { NetworkQuestionSettingsLifecycle } from '../types';

const initialState: NetworkQuestionSettingsLifecycle = {
  pending: false,
  fulfilled: undefined,
  rejected: undefined,
};

const reducer: Reducer<NetworkQuestionSettingsLifecycle, NetworkQuestionSettingsLoadAction> = (
  state = initialState,
  action
) => {
  switch (action.type) {
    case 'NETWORK_QUESTION_SETTINGS.LOAD_FULFILLED':
      return setFulfilled(action.payload);
    case 'NETWORK_QUESTION_SETTINGS.LOAD_PENDING':
      return setPending();
    case 'NETWORK_QUESTION_SETTINGS.LOAD_REJECTED':
      return setRejected(action.payload.error);
    default:
      return state;
  }
};

export default reducer;
